import React from 'react';
import { Link } from 'react-router-dom';

import { Show } from '@bd-uikit-web/React/Utils';
import { Form } from '@bd-uikit-web/React/Form';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

export default class Subscriptions extends React.Component {
  constructor(props) {
    super();

    this.props = props;

    this.state = {
      sending: false,
      user: null,
      subscriptionLoaded: false,
      activeSubscription: false,
      subscription: {},
      plans: [],
    };

    this.cancelSubscription = this.cancelSubscription.bind(this);
  }

  componentWillMount() {
    if (!bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('SUBSCRIPTIONS');
      this.props.history.push('/');
      return;
    }

    // Get available plans
    const apiLink = '/plans';

    this.setStateSending();
    bdReq.get(apiLink)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
            plans: [],
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.setState({
          sending: false,
          plans: body,
        });
      });

    // Get active subscription
    // getUser is synchronous now
    const user = bdAuth.getUser();
    if (user === null) {
      this.setState({
        sending: false,
      });
    } else {
      this.setState({
        user,
      });

      this.getSubscriptions(`/users/${user.id}/subscriptions`);
    }
  }


  getSubscriptions(apiLink) {
    bdReq.get(apiLink)
      .then(({ success, body }) => {
        console.log(body)
        if (success && body.plan !== undefined) {
          this.setState({
            subscriptionLoaded: true,
            activeSubscription: Boolean(body.plan),
            subscription: body.plan,
            sending: false,
          });

          return;
        }

        this.setState({
          subscriptionLoaded: true,
        });
      });
  }


  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  cancelSubscription() {
    const apiLink = `/users/${this.state.user.id}/subscriptions/cancel`;

    // this.setStateSending();
    bdReq.delete(apiLink)
      .then(({ success }) => {
        if (success) {
          window.location.reload();
          return;
        }
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          msg: 'Something went wrong.',
        });
      });
  }

  render() {
    return (
      <div>
        <Show condition={ this.state.subscriptionLoaded && this.state.activeSubscription }>
          <section className="row">
            <div className="col-12">
              <h4 className="h--underline h--regular-weight">Current Subscription</h4>

              <div className="current-plan-card">
                <section className="row">
                  <div className="col-6 col-sm-full">
                    <section className="row">
                      <div className="col-8 col-sm-full">
                        <h5 className="h--lower h--spacing-sm h--medium-weight pull-left">
                          { this.state.subscription.name }
                        </h5>

                        <h5 className="current-plan-card__price pull-right" data-currency="$" data-period="/month">
                          { this.state.subscription._embedded ?
                            this.state.subscription._embedded.pricingTier.price :
                            ''
                          }
                        </h5>

                        <div className="clear"></div>

                        <ul className="current-plan-card__features">
                          {this.state.subscription._embedded ?

                            this.state.subscription._embedded.benefits.map((benefit, i) => (
                              <li key={i}>
                                <span className="checkmark-green ion-checkmark" />
                                { benefit.description }
                              </li>
                            ))
                            : ''
                          }
                        </ul>
                      </div>
                    </section>
                  </div>

                  <div className="col-6 col-sm-full">
                    <h5 className="h--lower h--medium-weight">Subscription status</h5>

                    <h5 className="h--lower h--regular-weight h--spacing-sm">Breakdown:</h5>
                    <ul className="current-plan-card__features">
                      <li>
                        <div className="pull-left">
                          { this.state.subscription.name }
                        </div>

                        <div className="pull-right">
                          ${ this.state.subscription._embedded ?
                            this.state.subscription._embedded.pricingTier.price
                            : '' } / month
                        </div>

                        <div className="clear"></div>
                      </li>
                    </ul>

                    <h5 className="h--lower h--regular-weight h--spacing-sm pull-left">
                      Total
                    </h5>
                    <h5 className="h--lower h--medium-weight h--spacing-sm pull-right">
                      ${ this.state.subscription._embedded ?
                        this.state.subscription._embedded.pricingTier.price :
                        '' } / month
                    </h5>
                    <div className="clear"></div>

                  </div>
                </section>
              </div>
            </div>
          </section>
        </Show>

        <Show condition={ this.state.subscriptionLoaded && !this.state.activeSubscription }>
          <section className="row row--push-btm">
            <div className="col-3"></div>
            <div className="col-6 text-center col-sm-full">
              <h4 className="h--lower h--spacing-sm h--regular-weight">
                Subscriptions
              </h4>
              <h3 className="h--lower h--spacing-sm h--medium-weight">
                More features for the most compelling experience
              </h3>
              <p>
                Blackdove's streaming collection provides a rotating catalog of
                video art from the world's digital artists.
                The artwork includes top artists and open artists, combined into
                an open collection for viewing on televisions.
                The collection includes 100's of works on a constantly rotating basis.
                Subscribers also have the option to enter the artist marketplace to
                purchase specific works directly from the artist.
              </p>
            </div>
            <div className="col-3"></div>
          </section>
        </Show>

        <Show condition={ this.state.subscriptionLoaded && this.state.activeSubscription }>
          <section className="row">
            <div className="col-12">
              <h4 className="h--underline h--regular-weight">Available Subscriptions</h4>
            </div>
          </section>
        </Show>

        <Show condition={ this.state.subscriptionLoaded && this.state.activeSubscription }>
          <section className="row">
            {this.state.plans.map(function activeSubscriptionPlans(plan, i) {
              return (<div className="col-4 col-sm-full" key={i}>
                <div className="plan-card">
                  <div className="plan-card__label"></div>
                  <header className="plan-card__header">
                    <h5 className="h--lower h--spacing-sm h--regular-weight">
                      { plan.name }
                    </h5>
                    <h1 className="plan-card__price" data-currency="$" data-period="/month">
                      { plan._embedded.pricing.price }
                    </h1>
                  </header>
                  <ul className="plan-card__features">
                    {plan.benefits.map((benefit, j) => (
                      <li key={j}>{ benefit.description }</li>
                    ))}
                  </ul>
                  <footer className="plan-card__footer">
                    <Show condition={ plan.id !== this.state.subscription.id }>
                      <Link to={`/purchase-subscription/${plan.id}`}
                        className="btn btn--text-lower"
                      >
                        { this.state.subscription._embedded && plan._embedded.pricing.price >
                                      this.state.subscription._embedded.pricingTier.price ?
                          'Upgrade' : 'Downgrade' }
                      </Link>
                    </Show>
                    <Show condition={ plan.id === this.state.subscription.id }>
                      <Form onSubmit={ this.cancelSubscription }>
                        <button type="submit" disabled={ this.state.sending }
                          className="btn--no-float btn--outlined btn--text-lower"
                        >
                          Cancel subscription
                        </button>
                      </Form>
                    </Show>
                  </footer>
                </div>
              </div>);
            }, this)}
          </section>
        </Show>

        <Show className="container" condition={ this.state.subscriptionLoaded &&
          !this.state.activeSubscription }>
          <section className="row">
            <div className="col-12">
              <section className="row">
                {this.state.plans.map((plan, i) => (
                  <div className="col-4 col-sm-full" key={i}>
                    <div className={`plan-card plan-card${
                      (plan.recommended ? '--recommended' : '')}`
                    }>
                      <div className="plan-card__label"></div>
                      <header className="plan-card__header">
                        <h5 className="h--lower h--spacing-sm h--medium-weight">
                          { plan.name }
                        </h5>
                        <h1 className="plan-card__price" data-currency="$" data-period="/month">
                          { plan._embedded.pricing.price }
                        </h1>
                      </header>
                      <ul className="plan-card__features">
                        {plan.benefits.map((benefit, j) =>
                          <li key={j}>{ benefit.description }</li>
                        )}
                      </ul>
                      <footer className="plan-card__footer">
                        <Link to={`/purchase-subscription/${plan.id}`}
                          className="btn btn--text-lower"
                        >
                          Purchase
                        </Link>
                      </footer>
                    </div>
                  </div>
                ))}
              </section>
            </div>
          </section>
        </Show>

      </div>
    );
  }
}
